/**
 * 中文语言包
 */

export default {
  // 通用
  common: {
    ok: '确定',
    cancel: '取消',
    confirm: '确认',
    delete: '删除',
    edit: '编辑',
    add: '新增',
    save: '保存',
    reset: '重置',
    search: '搜索',
    clear: '清除',
    refresh: '刷新',
    export: '导出',
    import: '导入',
    upload: '上传',
    download: '下载',
    view: '查看',
    detail: '详情',
    back: '返回',
    submit: '提交',
    close: '关闭',
    loading: '加载中...',
    noData: '暂无数据',
    total: '共',
    items: '条',
    page: '页',
    go: '跳转',
    success: '成功',
    error: '错误',
    warning: '警告',
    info: '信息',
    yes: '是',
    no: '否',
    enable: '启用',
    disable: '禁用',
    statusLabel: '状态',
    action: '操作',
    actions: '操作',
    createTime: '创建时间',
    updateTime: '更新时间',
    remark: '备注',
    sort: '排序',
    more: '更多',
    expand: '展开',
    collapse: '收起',
    of: '共',
    enterprise: '企业',
    user: '用户',
    settings: '设置',
    // 状态
    status: {
      active: '启用',
      inactive: '禁用',
      archived: '已归档',
    },
  },

  // 异常页面
  exception: {
    notFound: '抱歉，您访问的页面不存在。',
    forbidden: '抱歉，您没有权限访问此页面。',
    serverError: '抱歉，服务器出现错误。',
    backHome: '返回首页',
    backPrevious: '返回上页',
    refresh: '刷新页面',
  },

  // 表格
  table: {
    columnSettings: '列设置',
    selectAll: '全选',
    columnSettingsTip: '拖拽调整列顺序，点击复选框显示/隐藏列',
  },

  // 表单扩展
  form: {
    required: '此字段为必填项',
    email: '请输入有效的邮箱地址',
    phone: '请输入有效的手机号码',
    password: '密码长度应在6-20位之间',
    confirmPassword: '两次输入的密码不一致',
    username: '用户名长度应在3-20位之间',
    select: '请选择',
    input: '请输入',
    upload: '请上传文件',
    date: '请选择日期',
    time: '请选择时间',
    number: '请输入数字',
    url: '请输入有效的URL地址',
    idCard: '请输入有效的身份证号码',
    bankCard: '请输入有效的银行卡号',
    zipCode: '请输入有效的邮政编码',
    startDate: '开始日期',
    endDate: '结束日期',
  },

  // 菜单
  menu: {
    home: '首页',
    dashboard: '仪表板',
    workplace: '工作台',
    analysis: '分析页',
    monitor: '监控页',

    product: '商品管理',
    productList: '商品列表',
    productAdd: '新增商品',
    productEdit: '编辑商品',
    productCategory: '商品分类',
    categoryList: '分类管理',
    productBrand: '品牌管理',
    brandList: '品牌管理',
    labelList: '标签管理',
    templateList: '模板管理',
    productUnit: '计量单位',
    productSku: 'SKU管理',
    skuList: 'SKU列表',
    moqTemplateList: '起售模板',
    categoryShipmentTemplateList: '大类起运模版',
    priceMonitor: '价格监控',
    productConfig: '商品配置',
    businessOrder: '业务订单',

    inventory: '库存管理',
    inventoryList: '库存列表',
    inventoryInbound: '入库管理',
    inventoryOutbound: '出库管理',
    inventoryTransfer: '库存调拨',
    inventoryCheck: '库存盘点',

    order: '订单管理',
    orderList: '订单列表',
    orderDetail: '订单详情',
    orderRefund: '退款管理',
    orderAfterSale: '售后管理',
    salesOrder: '销售订单',
    pendingApproval: '待审批订单',
    purchaseOrder: '采购单',
    returnOrder: '退货单',
    purchaseAfterSales: '采购售后单',
    salesAfterSales: '销售售后单',
    paymentRecord: '付款记录',
    orderStatistics: '订单统计',
    cart: '购物车',
    mall: '采购商城',

    customer: '客户管理',
    customerList: '客户列表',
    customerCategory: '客户分类',
    customerQuotes: '报价单',
    customerPrices: '客户定价',
    customerProducts: '商品授权',
    customerGroup: '客户分组',
    customerLevel: '客户等级',
    customerLevels: '客户等级',
    levelPrices: '等级价格',
    salesmen: '销售员管理',
    customerInfo: '客户信息',
    customerType: '客户类型',

    finance: '财务管理',
    financeAccount: '账户管理',
    financeFlow: '资金流水',
    financeStatement: '财务报表',

    marketing: '营销管理',
    marketingCoupon: '优惠券',
    marketingPromotion: '促销活动',
    marketingMember: '会员管理',

    content: '内容管理',
    contentArticle: '文章管理',
    contentBanner: '轮播图',
    contentNotice: '公告管理',

    system: '系统管理',
    systemUser: '用户管理',
    systemRole: '角色管理',
    systemPermission: '权限管理',
    systemDept: '部门管理',
    systemDict: '字典管理',
    systemConfig: '系统配置',
    systemLog: '操作日志',
    systemMenu: '菜单管理',

    personal: '个人中心',
    personalInfo: '个人信息',
    personalPassword: '修改密码',
    personalSetting: '个人设置',

    // 管理模式
    adminMode: '管理模式',
    businessMode: '业务模式',
    adminDashboard: '管理概览',
    tenantSettings: '租户设置',
    openapiApps: '对外接口管理',
    organization: '组织管理',
    tenantManagement: '租户管理',
    subTenantManagement: '子租户管理',
    organizationManagement: '组织管理',
    memberManagement: '成员管理',
    themeConfig: '主题配置',

    // 管理模式 - 职能域分组
    orgPeople: '组织人员',
    systemOrganization: '组织架构',
    systemUsers: '用户管理',
    systemPosition: '岗位管理',
    accessControl: '访问控制',
    systemRoles: '角色管理',
    systemPermissions: '权限资源',
    systemMenus: '菜单管理',
    systemDataScope: '数据范围',
    systemFieldPermission: '字段权限',
    securityAudit: '安全审计',
    permissionOverride: '权限覆盖',
    permissionTracing: '权限溯源',
    permissionAudit: '权限审计',
    loginLog: '登录日志',
    auditLog: '审计日志',
    messageCenter: '消息中心',
    subscription: '我的订阅',
    adminOrders: '订单记录',
    invoices: '发票管理',
    mallDecoration: '商城装修',

    // 业务模块
    distributionManagement: '分销管理',
    productAssign: '商品铺货',
    pricingStrategies: '定价策略',
    networkTopology: '网络拓扑',
    tradeManagement: '交易管理',
    tradeQuotes: '客户报价',
    tradeOrders: '客户订单',
    tradeCommission: '佣金结算',
    warehouseManagement: '仓库管理',
    warehouse: '仓库管理',
    warehousePermissions: '仓库授权',
    warehouseReceipt: '入库单',
    warehouseList: '仓库列表',
    inventoryMgmt: '库存管理',
    inboundManagement: '入库管理',
    outboundManagement: '出库管理',
    stocktakeManagement: '盘点管理',
    warehouseCarrierConfig: '仓库快递配置',
    settlementManagement: '结算管理',
    settlementList: '结算列表',
    creditLine: '授信额度',
    settlementRule: '结算规则',
    reportCenter: '报表中心',
    salesReport: '销售报表',
    inventoryReport: '库存报表',
    financeReport: '财务报表',
    financeInvoices: '发票管理',
    financeManagement: '财务管理',
    settlementBills: '结算单',
    accounts: '账户管理',
    financeReceipts: '收款单',
    financeDisbursements: '付款单',
    financeFundAccounts: '资金账户',
    logisticsManagement: '物流管理',
    shippingCarriers: '快递公司',
    shipments: '发货记录',
    logisticsTracking: '物流跟踪',
    carrierPermissions: '快递权限配置',
    promotionManagement: '推广管理',
    promotionProjects: '推广项目',
    promotionCoupon: '优惠券',
    draftOrders: '草稿单管理',
    channel: '渠道管理',
    channelShops: '网店管理',
    channelList: '渠道列表',
    moqTemplateList: '起售模板',
    categoryShipmentTemplateList: '大类起运模版',
    cargoManagement: '货盘管理',
    cargoLots: '货盘列表',
    cargoAllocations: '货盘分配',
    cargoDistributors: '分销商管理',
    cargoProducts: '商品铺货',
    cargoPricing: '定价策略',
    ycodeManagement: 'Y码管理',
    ycodelist: 'Y码列表',
    ycodeRedemptions: '核销记录',
    ycodePrices: '价格配置',
    productWhitelist: '产品白名单',
    productBundles: '组合方案',
  },

  // 页面标题
  title: {
    dashboard: '仪表板',
    login: '登录',
    register: '注册',
    forgotPassword: '忘记密码',
    resetPassword: '重置密码',
    profile: '个人资料',
    settings: '系统设置',
    notFound: '页面不存在',
    serverError: '服务器错误',
    unauthorized: '未授权',
    forbidden: '禁止访问',
  },


  // 操作提示
  message: {
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    logoutSuccess: '退出成功',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    deleteConfirm: '确定要删除吗？',
    updateSuccess: '更新成功',
    updateFailed: '更新失败',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败',
    exportSuccess: '导出成功',
    exportFailed: '导出失败',
    importSuccess: '导入成功',
    importFailed: '导入失败',
    copySuccess: '复制成功',
    copyFailed: '复制失败',
    networkError: '网络错误',
    serverError: '服务器错误',
    paramError: '参数错误',
    permissionDenied: '权限不足',
    operationSuccess: '操作成功',
    operationFailed: '操作失败',
    noChanges: '没有变更',
  },

  // 头部导航
  header: {
    profile: '个人资料',
    settings: '设置',
    guide: '操作手册',
    logout: '退出登录',
    notifications: '通知',
    allNotifications: '查看全部通知',
    search: '搜索',
    help: '帮助',
    support: '支持',
    language: '语言',
    theme: '主题',
  },

  // 登录页面
  login: {
    title: 'Coolbuy 3.0',
    subtitle: '企业级 PaaS 管理平台',
    username: '用户名',
    password: '密码',
    remember: '记住登录状态',
    forgot: '忘记密码？',
    login: '登录',
    register: '注册账号',
    thirdParty: '第三方登录',
    usernameRequired: '请输入用户名',
    passwordRequired: '请输入密码',
    loginSuccess: '登录成功',
    loginFailed: '用户名或密码错误',
    // 统一登录页面新增
    usernameLabel: '用户名',
    usernamePlaceholder: '请输入用户名',
    passwordLabel: '密码',
    passwordPlaceholder: '请输入密码',
    captcha: '验证码',
    captchaLabel: '验证码',
    captchaPlaceholder: '请输入验证码',
    captchaRequired: '请输入验证码',
    captchaInvalid: '请输入正确的验证码',
    captchaError: '获取验证码失败',
    getCaptcha: '获取验证码',
    quickLogin: '快速登录',
    quickLoginSuccess: '快速登录成功',
    quickLoginFailed: '快速登录失败',
    success: '登录成功',
    failed: '登录失败',
    welcomeBack: '欢迎回来！',
    errorMessage: '用户名或密码错误，请重试',
  },

  // 设置
  settings: {
    title: '系统设置',
    language: '语言',
    theme: '主题',
    layout: '布局',
    navigation: '导航',
    content: '内容区域',
    footer: '页脚',
    other: '其他设置',
    
    lightTheme: '浅色主题',
    darkTheme: '深色主题',
    autoTheme: '跟随系统',
    
    sideLayout: '侧边布局',
    topLayout: '顶部布局',
    mixLayout: '混合布局',
    
    fixedHeader: '固定头部',
    fixedSidebar: '固定侧边栏',
    showTabs: '显示标签页',
    showBreadcrumb: '显示面包屑',
    showFooter: '显示页脚',
    
    compactMode: '紧凑模式',
    weakMode: '色弱模式',
    colorBlind: '色盲模式',
    
    reset: '恢复默认',
    resetConfirm: '确定要恢复默认设置吗？',
  },

  // 工作台
  workplace: {
    welcome: '早安，{{name}}，祝你开心每一天！',
    welcomeSystem: '欢迎使用系统，今日',
    quickNav: '快捷导航',
    recentVisit: '最近访问',
    myProject: '我的项目',
    quickEntry: '快速入口',
    announcement: '通知公告',
    todoList: '待办事项',
    workProgress: '工作进度',
    teamActivity: '团队动态',
    refreshData: '刷新数据',

    todayData: '今日数据',
    totalUsers: '总用户数',
    totalOrders: '总订单数',
    totalRevenue: '总营收',
    newUsers: '新增用户',
    newOrders: '新增订单',
    todayRevenue: '今日营收',

    // 实时数据
    realTimeData: '今日实时数据',
    realTime: '实时',
    todayOrderCount: '今日订单',
    todaySalesAmount: '今日销售额',
    onlineUsers: '在线用户',
    conversionRate: '转化率',

    // 系统状态
    systemStatus: '系统状态',
    normal: '正常',
    cpuUsage: 'CPU使用率',
    memoryUsage: '内存使用率',
    diskUsage: '磁盘使用率',
    performanceIndex: '性能指标',

    // 图表
    salesTrend: '销售额趋势',
    regionSales: '销售地区分布',
    categorySales: '产品分类销量',
    salesAndOrders: '销售额与订单量',

    chart: {
      orderTrend: '订单趋势',
      userGrowth: '用户增长',
      revenueTrend: '营收趋势',
      categoryDistribution: '品类分布',
      regionDistribution: '地区分布',
      last30Days: '最近30天',
    },
  },

  // 商品相关
  product: {
    title: '商品管理',
    name: '商品名称',
    code: '商品编码',
    category: '商品分类',
    brand: '品牌',
    price: '价格',
    costPrice: '成本价',
    retailPrice: '零售价',
    wholesalePrice: '批发价',
    stock: '库存',
    unit: '单位',
    spec: '规格',
    barcode: '条形码',
    description: '商品描述',
    image: '商品图片',
    status: '状态',
    onSale: '上架',
    offSale: '下架',
    createProduct: '新增商品',
    editProduct: '编辑商品',
    viewProduct: '查看商品',
    deleteProduct: '删除商品',
    batchImport: '批量导入',
    batchExport: '批量导出',
  },

  // 订单相关
  order: {
    title: '订单管理',
    orderNo: '订单编号',
    orderType: '订单类型',
    orderStatus: '订单状态',
    orderAmount: '订单金额',
    payAmount: '支付金额',
    payStatus: '支付状态',
    payTime: '支付时间',
    customer: '客户',
    receiver: '收货人',
    receiverPhone: '收货电话',
    receiverAddress: '收货地址',
    deliveryStatus: '发货状态',
    deliveryTime: '发货时间',
    expressNo: '快递单号',
    remark: '备注',
    createOrder: '创建订单',
    viewOrder: '查看订单',
    cancelOrder: '取消订单',
    confirmOrder: '确认订单',
    shipOrder: '发货',
    completeOrder: '完成订单',
    refund: '退款',
    afterSale: '售后',
    pending: '待付款',
    paid: '已付款',
    shipped: '已发货',
    completed: '已完成',
    cancelled: '已取消',
  },

  // 客户相关
  customer: {
    title: '客户管理',
    name: '客户名称',
    code: '客户编码',
    type: '客户类型',
    level: '客户等级',
    contact: '联系人',
    phone: '联系电话',
    email: '邮箱',
    address: '地址',
    creditLimit: '授信额度',
    balance: '余额',
    points: '积分',
    createCustomer: '新增客户',
    editCustomer: '编辑客户',
    viewCustomer: '查看客户',
    deleteCustomer: '删除客户',
  },

  // 库存相关
  inventory: {
    title: '库存管理',
    warehouse: '仓库',
    location: '库位',
    quantity: '数量',
    availableQty: '可用数量',
    lockedQty: '锁定数量',
    inbound: '入库',
    outbound: '出库',
    transfer: '调拨',
    stocktaking: '盘点',
    inboundNo: '入库单号',
    outboundNo: '出库单号',
    transferNo: '调拨单号',
    createInbound: '创建入库单',
    createOutbound: '创建出库单',
    createTransfer: '创建调拨单',
  },

  // 财务相关
  finance: {
    title: '财务管理',
    account: '账户',
    balance: '余额',
    income: '收入',
    expense: '支出',
    transaction: '交易',
    transactionNo: '交易单号',
    transactionType: '交易类型',
    transactionAmount: '交易金额',
    transactionTime: '交易时间',
    receipt: '收款',
    payment: '付款',
    statement: '对账单',
    invoice: '发票',
  },

  // 分类
  category: {
    electronics: '电子产品',
    clothing: '服装',
    books: '图书',
    home: '家居',
  },

  // 状态
  status: {
    active: '启用',
    inactive: '禁用',
    pending: '待审核',
    approved: '已审核',
    rejected: '已拒绝',
  },

  // 账户设置
  account: {
    settings: '账号设置',
    security: '安全设置',
    notification: '通知偏好',
    personalization: '个性化',
    binding: '账号绑定',
    changePassword: '修改密码',
    twoFactorAuth: '两步验证',
    loginDevices: '登录设备',
    loginLog: '登录日志',
    bindPhone: '绑定手机',
    bindEmail: '绑定邮箱',
    bindWechat: '绑定微信',
    bindWecom: '绑定企业微信',
    unbind: '解绑',
    bound: '已绑定',
    unbound: '未绑定',
    securityLevel: '安全等级',
    securityTips: '安全提示',
  },

  // 个人中心
  profile: {
    title: '个人中心',
    messageCenter: '消息中心',
    myWorkspace: '我的工作台',
    basicInfo: '基本信息',
    avatar: '头像',
    nickname: '昵称',
    email: '邮箱',
    phone: '手机号',
    department: '部门',
    position: '职位',
    joinDate: '入职日期',
    noMessages: '暂无消息',
    allRead: '全部已读',
    unread: '未读',
    read: '已读',
  },

  // 系统管理
  system: {
    title: '系统管理',
    // 用户管理
    user: {
      title: '用户管理',
      username: '用户名',
      realName: '真实姓名',
      nickname: '昵称',
      email: '邮箱',
      phone: '手机号',
      avatar: '头像',
      status: '状态',
      role: '角色',
      department: '部门',
      position: '职位',
      createUser: '新增用户',
      editUser: '编辑用户',
      deleteUser: '删除用户',
      resetPassword: '重置密码',
      assignRole: '分配角色',
    },
    // 角色管理
    role: {
      title: '角色管理',
      roleName: '角色名称',
      roleCode: '角色编码',
      description: '描述',
      status: '状态',
      createRole: '新增角色',
      editRole: '编辑角色',
      deleteRole: '删除角色',
      assignPermission: '分配权限',
    },
    // 组织管理
    org: {
      title: '组织管理',
      orgName: '组织名称',
      orgCode: '组织编码',
      parentOrg: '上级组织',
      leader: '负责人',
      phone: '联系电话',
      email: '邮箱',
      address: '地址',
      sort: '排序',
      createOrg: '新增组织',
      editOrg: '编辑组织',
      deleteOrg: '删除组织',
    },
    // 菜单管理
    menu: {
      title: '菜单管理',
      menuName: '菜单名称',
      menuType: '菜单类型',
      icon: '图标',
      path: '路径',
      component: '组件',
      permission: '权限标识',
      sort: '排序',
      visible: '是否可见',
      directory: '目录',
      menuItem: '菜单',
      button: '按钮',
      createMenu: '新增菜单',
      editMenu: '编辑菜单',
      deleteMenu: '删除菜单',
    },
    // 字典管理
    dict: {
      title: '字典管理',
      dictName: '字典名称',
      dictCode: '字典编码',
      dictValue: '字典值',
      createDict: '新增字典',
      editDict: '编辑字典',
      deleteDict: '删除字典',
    },
    // 日志管理
    log: {
      title: '操作日志',
      operator: '操作人',
      operateType: '操作类型',
      operateTime: '操作时间',
      ip: 'IP地址',
      browser: '浏览器',
      os: '操作系统',
      result: '操作结果',
      detail: '详情',
    },
  },

  // 管理概览仪表盘
  dashboard: {
    overview: '管理概览',
    refresh: '刷新',
    today: '今日',
    thisWeek: '本周',
    thisMonth: '本月',
    last7Days: '近7天',
    last30Days: '近30天',

    // 销售指标
    salesMetrics: '销售指标',
    salesAmount: '销售额',
    orderCount: '订单数',
    pendingShip: '待发货',
    afterSale: '售后待处理',
    vsLastPeriod: '较上期',
    vsYesterday: '较昨日',

    // 库存指标
    inventoryMetrics: '库存指标',
    skuCount: 'SKU总数',
    inventoryValue: '库存金额',
    inventoryWarning: '库存预警',
    todayInOut: '今日出入库',
    newToday: '今日新增',
    clickToView: '点击查看详情',
    inboundOutbound: '入库/出库',

    // 图表
    salesTrend: '销售趋势',
    turnoverRate: '库存周转率',
    monthlyTurnover: '本月周转',
    vsLastMonth: '较上月',

    // 库存预警弹窗
    skuCode: 'SKU编码',
    productName: '商品名称',
    warningType: '预警类型',
    currentStock: '当前库存',
    safeStock: '安全库存',
    warehouse: '仓库',
    lowStock: '低库存',
    overstock: '积压',
    items: '项',
    noWarnings: '暂无预警',

    // 状态
    increase: '上涨',
    decrease: '下跌',
    noData: '暂无数据',
    loadError: '加载数据失败',
  },

  // IT管理统计（admin模式）
  adminStats: {
    // 标题
    itManagement: 'IT管理统计',
    orgUserStats: '组织/用户/角色',
    logSecurityStats: '日志/安全',
    trendAnalysis: '趋势分析',
    distributionAnalysis: '分布分析',
    serviceStatus: '服务状态',

    // 组织统计
    organization: '组织架构',
    subTenants: '子租户',
    departments: '部门',

    // 用户统计
    totalUsers: '用户总数',
    activeToday: '今日活跃',
    newThisWeek: '本周新增',
    userStatus: '用户状态',
    activeInactiveDisabled: '活跃/未激活/禁用',
    vsLastPeriod: '较上期',
    vsYesterday: '较昨日',

    // 角色统计
    totalRoles: '角色总数',
    systemRoles: '系统角色',
    customRoles: '自定义角色',

    // 日志统计
    todayLogins: '今日登录',
    successRate: '成功率',
    todayOperations: '今日操作',
    highRisk: '高危',
    failed: '失败',

    // 系统健康
    apiPerformance: 'API性能',
    storageUsage: '存储使用',
    files: '文件',
    latency: '延迟',

    // 趋势图
    userActivity: '用户活跃',
    loginTrend: '登录趋势',
    auditTrend: '操作日志',
    last7Days: '近7天',
    last30Days: '近30天',
    customRange: '自定义',

    // 分布图
    userStatusDist: '用户状态',
    roleDistribution: '角色分布',
    operationTypeDist: '操作类型',
    deviceTypeDist: '设备类型',

    // 服务状态
    status: {
      online: '在线',
      offline: '离线',
      degraded: '降级',
    },

    // 错误
    loadError: '加载IT统计数据失败',
  },

  // 组织管理
  organization: {
    // 组织切换器
    selectOrg: '选择组织',
    switchSuccess: '已切换到 {{name}}',
    switchFailed: '切换组织失败',
    primary: '主组织',
    current: '当前',
    loadFailed: '加载组织列表失败',
    selectRequired: '请选择一个组织',
    selectTitle: '选择工作组织',
    selectHint: '请选择您要工作的组织',

    // 页面标题
    title: '组织架构管理',
    description: '管理租户内的组织架构',
    treeView: '列表',
    chartView: '结构图',
    chartViewComingSoon: '组织结构图视图即将推出',

    // 基本字段
    name: '组织名称',
    shortName: '简称',
    code: '组织编码',
    status: '状态',
    level: '层级',
    path: '路径',
    sortOrder: '排序',
    root: '根组织',
    childrenCount: '下级数',

    // 操作
    add: '新增组织',
    edit: '编辑组织',
    detail: '组织详情',
    addChild: '新增下级',
    deleteConfirm: '确认删除',
    deleteHint: '确定要删除组织"{{name}}"吗？',
    deleteWithChildren: '该组织存在下级组织，请先删除下级组织。',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    createSuccess: '创建成功',
    createFailed: '创建失败',
    updateSuccess: '更新成功',
    updateFailed: '更新失败',
    loadDetailFailed: '加载详情失败',

    // 表单
    parentOrg: '上级组织',
    basicInfo: '基本信息',
    contactInfo: '联系信息',
    addressInfo: '地址信息',
    businessInfo: '企业信息',
    validityPeriod: '有效期',
    systemInfo: '系统信息',

    // 表单字段
    namePlaceholder: '请输入组织名称',
    nameRequired: '请输入组织名称',
    shortNamePlaceholder: '请输入简称',
    codePlaceholder: '请输入组织编码',
    codeRequired: '请输入组织编码',
    codePattern: '只能包含字母、数字、-和_',
    relationTypeLabel: '关系类型',
    relationTypePlaceholder: '请选择关系类型',
    relationTypeRequired: '请选择关系类型',

    // 联系信息
    contactName: '联系人',
    contactNamePlaceholder: '请输入联系人姓名',
    contactPhone: '联系电话',
    contactPhonePlaceholder: '请输入电话号码',
    contactEmail: '邮箱',
    contactEmailPlaceholder: '请输入邮箱',
    emailInvalid: '邮箱格式不正确',

    // 地址信息
    province: '省份',
    provincePlaceholder: '省份',
    city: '城市',
    cityPlaceholder: '城市',
    district: '区/县',
    districtPlaceholder: '区/县',
    region: '地区',
    address: '详细地址',
    addressPlaceholder: '请输入详细地址',

    // 企业信息
    creditCode: '统一社会信用代码',
    creditCodePlaceholder: '请输入统一社会信用代码',
    legalPerson: '法人代表',
    legalPersonPlaceholder: '请输入法人代表',
    bankName: '开户银行',
    bankNamePlaceholder: '请输入开户银行',
    bankAccount: '银行账号',
    bankAccountPlaceholder: '请输入银行账号',
    validFrom: '生效日期',
    validTo: '失效日期',
    remark: '备注',
    remarkPlaceholder: '请输入备注',
    noData: '暂无数据',

    // 筛选
    searchPlaceholder: '搜索名称或编码',
    filterByType: '按类型筛选',
    filterByStatus: '按状态筛选',

    // 成员管理
    members: '成员管理',
    member: '成员',
    memberRole: '角色',
    addMember: '添加成员',
    removeMemberConfirm: '确定移除该成员？',
    loadMembersFailed: '加载成员列表失败',
    addMemberSuccess: '添加成员成功',
    addMemberFailed: '添加成员失败',
    removeMemberSuccess: '移除成员成功',
    removeMemberFailed: '移除成员失败',
    noMembers: '该组织暂无成员',
    selectUser: '选择用户',
    selectUserRequired: '请选择用户',
    searchUserPlaceholder: '搜索姓名或用户名',
    noUsersFound: '未找到用户',
    setPrimary: '设为主组织',
    primaryOrg: '主组织',
    role: {
      admin: '管理员',
      manager: '经理',
      member: '成员',
      viewer: '访客',
    },

    // 组织操作
    move: '迁移',
    moveSuccess: '组织迁移成功',
    moveFailed: '组织迁移失败',
    moveWarning: '迁移组织将同时移动其所有子组织',
    currentOrg: '当前组织',
    newParent: '新的上级组织',
    selectNewParent: '请选择新的上级组织',
    selectParent: '选择上级组织',
    rootLevel: '根级别',

    merge: '合并',
    mergeSuccess: '组织合并成功',
    mergeFailed: '组织合并失败',
    mergeWarning: '合并后源组织将被删除，所有子组织将移动到目标组织下',
    sourceOrg: '源组织',
    targetOrg: '目标组织',
    selectBelow: '请在下方选择',
    targetOrganization: '目标组织',
    selectTarget: '请选择目标组织',
    selectTargetOrg: '选择目标组织',
    mergeUsers: '迁移用户',
    mergeUsersHint: '如果启用，源组织的所有用户将被移动到目标组织',

    split: '拆分',
    splitSuccess: '组织拆分成功',
    splitFailed: '组织拆分失败',
    splitHint: '从选定组织中拆分出新组织，可以选择性地迁移子组织和用户',
    newOrgName: '新组织名称',
    newOrgCode: '新组织编码',
    sameParent: '与源组织同级',
    sameParentHint: '如果启用，新组织将与源组织同级；否则新组织将作为源组织的子组织',
    moveChildren: '迁移子组织',
    moveUsers: '迁移用户',
    keepInSource: '保留在源组织',
    moveToNew: '迁移到新组织',
    noChildren: '没有子组织',
    noUsers: '该组织暂无用户',

    // 关系类型
    relationType: {
      headquarters: '总部',
      subsidiary: '子公司',
      branch: '分公司',
      division: '事业部',
      region: '区域',
      store: '门店',
      direct_store: '直营店',
      franchise: '加盟店',
      dealer: '经销商',
      distributor: '分销商',
      agent: '代理商',
      ecommerce: '电商渠道',
      supplier: '供应商',
      manufacturer: '制造商',
      logistics: '物流商',
      warehouse: '仓库',
      customer: '客户',
      partner: '合作伙伴',
    },
  },

  // 业务管理
  business: {
    // 客户关系管理
    customer: {
      title: '客户管理',
      myCustomers: '我的客户',
      asCustomer: '我作为客户',
      add: '添加客户',
      edit: '编辑客户',
      createNew: '新建客户',
      addExisting: '添加已有租户',
      customerName: '客户名称',
      customerCode: '客户编码',
      relationType: '关系类型',
      tenantType: '租户类型',
      industry: '所属行业',
      aliasName: '别名',
      contactName: '联系人',
      contactPhone: '联系电话',
      ownerName: '所属企业',
      ownerCode: '企业编码',
      addedAt: '添加时间',
      selfCreated: '自建客户',
      searchPlaceholder: '搜索客户名称或编码',
      filterByRelationType: '按关系类型筛选',
      namePlaceholder: '请输入客户名称',
      codePlaceholder: '请输入客户编码',
      aliasNamePlaceholder: '请输入别名（可选）',
      contactNamePlaceholder: '请输入联系人姓名',
      contactPhonePlaceholder: '请输入联系电话',
      remarksPlaceholder: '请输入备注信息',
      searchTenantPlaceholder: '搜索租户名称或编码',
      selectTenant: '选择租户',
      selectTenantPlaceholder: '请选择要添加的租户',
      loadFailed: '加载客户列表失败',
      addSuccess: '添加客户成功',
      addFailed: '添加客户失败',
    },
    // 关系类型
    relationType: {
      supplier: '供应商',
      distributor: '分销商',
      both: '双向合作',
    },
    // 可见性设置
    visibility: {
      title: '可见性设置',
      settings: '可见性设置',
      visibleToAll: '对所有租户可见',
      allowTenantTypes: '允许的租户类型',
      allowIndustries: '允许的行业',
      selectTenantTypes: '请选择允许的租户类型',
      selectIndustries: '请选择允许的行业',
      loadFailed: '加载可见性设置失败',
    },
  },

  // 平台管理
  platform: {
    // 租户池管理
    tenantPool: {
      title: '租户池管理',
      create: '创建租户池',
      edit: '编辑租户池',
      name: '池名称',
      code: '池编码',
      description: '描述',
      status: '状态',
      memberCount: '成员数量',
      searchPlaceholder: '搜索池名称或编码',
      namePlaceholder: '请输入租户池名称',
      codePlaceholder: '请输入租户池编码（可选）',
      descriptionPlaceholder: '请输入租户池描述',
      manageMembers: '管理成员',
      addMembers: '添加成员',
      tenantName: '租户名称',
      tenantCode: '租户编码',
      tenantType: '租户类型',
      industry: '所属行业',
      joinedAt: '加入时间',
      noAvailableTenants: '没有可添加的租户',
      selectedCount: '已选择 {{count}} 个租户',
      loadFailed: '加载租户池列表失败',
      loadMembersFailed: '加载成员列表失败',
      loadAvailableTenantsFailed: '加载可用租户失败',
      createSuccess: '创建租户池成功',
      updateSuccess: '更新租户池成功',
      deleteSuccess: '删除租户池成功',
      deleteFailed: '删除租户池失败',
      deleteConfirm: '确定要删除租户池"{{name}}"吗？此操作不可恢复。',
      addMembersSuccess: '成功添加 {{count}} 个成员',
      addMembersFailed: '添加成员失败',
      removeMemberSuccess: '移除成员成功',
      removeMemberFailed: '移除成员失败',
      removeMemberConfirm: '确定要将此租户从池中移除吗？',
    },
  },

  // 版本更新记录
  changelog: {
    title: '版本更新记录',
    version: '版本',
    buildTime: '构建时间',
    clickToView: '点击查看更新记录',
    loadError: '加载更新记录失败',
    noData: '暂无更新记录',
    type: {
      feature: '新功能',
      fix: '问题修复',
      improvement: '优化改进',
      breaking: '重大变更',
    },
  },

  // AI 助手
  aiChat: {
    title: 'AI 助手',
  },
};